import React from "react";
import SinginView from "./SinginView";

const SinginViewController = () => {
    return <SinginView />
}

export default SinginViewController;